import clsx from 'clsx';
import React, { forwardRef } from 'react';
import { flattenChildren } from '../../utils';
import { Avatar } from '../Avatar/Avatar';
import { AvatarProvider } from '../Avatar/AvatarContext';
import { Box } from '../Box';
import './AvatarGroup.css';
export const AvatarGroup = forwardRef(function AvatarGroup(props, ref) {
    const { children, className, variant, size, truncate = 8, ...rest } = props;
    const childCount = React.Children.count(children);
    const safeTruncate = childCount === truncate + 1 ? childCount : truncate;
    const isTruncated = childCount > truncate + 1;
    return (React.createElement(Box.Restricted, { ...rest, ref: ref, className: clsx('mollie-ui-avatar-group', {
            [`mollie-ui-avatar-group--${size}`]: size,
        }, className) },
        flattenChildren(children)
            .slice(0, safeTruncate)
            .map((child) => {
            if (React.isValidElement(child) && child.type === Avatar) {
                return React.cloneElement(child, {
                    variant,
                    size,
                });
            }
            return child;
        }),
        isTruncated && (React.createElement(AvatarProvider, { isTruncated: isTruncated },
            React.createElement(Avatar, { variant: variant, size: size }, `+${childCount - truncate}`)))));
});
//# sourceMappingURL=AvatarGroup.js.map